const faqData = [
  {
    question: "브레인시티 메디스파크는 어디에 들어서나요?",
    answer: `
브레인시티 메디스파크는 경기도 평택시 브레인시티 일반산업단지 공동주택용지 10BL에 공급되는 브랜드 아파트입니다.<br/><br/>

사업지는 경기도 평택시 장안동 브레인시티 일반산업단지 내 10BL에 위치하며 브레인시티 중심 생활권을 누릴 수 있는 핵심 입지입니다.<br/><br/>

카이스트 평택캠퍼스와 아주대학교 평택병원 예정부지, 중심상업지구와 가까워 교육·의료·생활 인프라를 동시에 기대할 수 있는 미래가치 높은 주거단지입니다.
`,
  },

  {
    question: "브레인시티 메디스파크는 몇 세대 규모인가요?",
    answer: `
브레인시티 메디스파크는 총 1,413세대 규모의 브랜드 대단지 아파트로 조성됩니다.<br/><br/>

단지는 지하 2층부터 지상 최고 35층 규모로 계획되어 있으며 브레인시티를 대표하는 랜드마크급 주거단지로 공급됩니다.<br/><br/>

대단지 프리미엄과 다양한 커뮤니티 시설을 함께 갖춘 실거주 중심 브랜드 아파트입니다.
`,
  },

  {
    question: "브레인시티 메디스파크는 어떤 타입이 있나요?",
    answer: `
브레인시티 메디스파크는 실수요 선호도가 높은 전용 59㎡와 84㎡ 타입으로 공급됩니다.<br/><br/>

전용 59㎡와 84㎡ 중심의 다양한 평면구성을 통해 신혼부부부터 4인 가족까지 폭넓은 수요층을 고려한 상품으로 계획되었습니다.<br/><br/>

4Bay 중심 특화설계와 효율적인 공간 활용이 가능한 브랜드 평면이 적용될 예정입니다.
`,
  },

  {
    question: "브레인시티 메디스파크의 교통환경은 어떤가요?",
    answer: `
브레인시티 메디스파크는 경부고속도로와 평택제천고속도로 접근성이 우수하며 수도권 남부 광역교통망 이용이 편리한 입지입니다.<br/><br/>

평택지제역 SRT와 GTX-A 연계 기대감, 수도권 전철 이용 등을 통해 서울 및 수도권 접근성이 더욱 향상될 것으로 기대됩니다.<br/><br/>

삼성전자 평택캠퍼스와 브레인시티 첨단산업단지 출퇴근이 편리한 직주근접 입지입니다.
`,
  },

  {
    question: "브레인시티 메디스파크의 생활인프라는 어떤가요?",
    answer: `
브레인시티 메디스파크는 브레인시티 중심상업지구와 다양한 생활편의시설을 가까이 이용할 수 있는 입지를 갖추고 있습니다.<br/><br/>

카이스트 평택캠퍼스와 아주대학교 평택병원 예정부지, 공원, 문화시설, 상업시설 등이 함께 조성될 예정으로 미래 생활환경이 우수합니다.<br/><br/>

브레인시티 개발 완료와 함께 더욱 풍부한 생활 인프라를 누릴 수 있는 주거단지입니다.
`,
  },

  {
    question: "브레인시티 메디스파크의 교육환경은 어떤가요?",
    answer: `
브레인시티 메디스파크는 유치원과 초·중학교 예정부지, 카이스트 평택캠퍼스와 연계되는 교육 인프라를 기대할 수 있는 입지입니다.<br/><br/>

자녀 교육환경과 미래 교육도시의 가치를 함께 고려하는 학부모 수요층의 관심이 높은 지역입니다.<br/><br/>

브레인시티 교육특화도시 개발과 함께 우수한 교육환경을 기대할 수 있습니다.
`,
  },

  {
    question: "브레인시티 메디스파크 모델하우스는 어떻게 방문하나요?",
    answer: `
브레인시티 메디스파크 모델하우스는 홈페이지 또는 대표번호를 통해 사전 방문예약 후 관람하는 것을 권장합니다.<br/><br/>

방문 시 타입별 평면, 분양가, 계약조건, 청약 일정, 잔여세대 현황 등 다양한 상담을 받아볼 수 있습니다.<br/><br/>

보다 원활한 상담을 위해 사전 예약 후 방문하는 것이 좋습니다.
`,
  },

  {
    question: "브레인시티 메디스파크는 어떤 분들에게 추천되나요?",
    answer: `
브레인시티 메디스파크는 평택 브레인시티 생활권을 선호하는 실수요자와 삼성전자 평택캠퍼스 직주근접을 원하는 수요자에게 추천되는 브랜드 아파트입니다.<br/><br/>

총 1,413세대 규모의 대단지와 전용 59㎡·84㎡ 중심 평면, 우수한 교통환경과 생활 인프라를 함께 갖춘 것이 장점입니다.<br/><br/>

브레인시티 개발호재와 카이스트 평택캠퍼스, 아주대학교 평택병원 등 미래가치를 함께 기대하는 수요자라면 관심 있게 살펴볼 만한 주거단지입니다.
`,
  },
];

export default faqData;